import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import TaxbillStaticsContainer from '../../containers/taxbill_statics/TaxbillStaticsContainer';

const TaxbillStaticsViewPage = () => {
  return (
    <div>
      <BreadcrumbsContainer
        title="세금계산서 관리/세금계산서 통계"
        icon="pay"
      />
      <TaxbillStaticsContainer />
    </div>
  );
};

export default TaxbillStaticsViewPage;
